// Lipirea unui document canonic adus pe felii (v. `services/felii.py`): felia
// de start plus completarea cu restul nivelurilor.

import { northUp } from "./canonical";
import type { CanonicalDoc } from "./canonical";

/** Documentul întreg, din felia de start plus completarea.
 *
 *  Antetul e al feliei de start — restul e o completare, nu un al doilea
 *  document (v. `felii.py`) — iar obiectele se pun cap la cap. Ordinea nu
 *  contează pentru niciun cititor: totul se caută după `id` sau după planșeu.
 *
 *  ORIENTAREA SE APLICĂ ȘI AICI. `northUp` se cheamă o singură dată, la
 *  citire, pe documentul întreg (v. nota lui din `Vizualizator`); completarea
 *  sosește însă mai târziu și pe un răspuns fără antet, deci ar intra
 *  neîntoarsă — adică un etaj desenat un sfert de tură față de parterul de
 *  lângă el. `crs`-ul e al documentului, nu al feliei, deci se ia de la start:
 *  transformarea e aceeași pentru amândouă. */
export function lipesteFelia(start: CanonicalDoc,
                             rest: { objects?: unknown[] }): CanonicalDoc {
  const completare = northUp({
    crs: (start as { crs?: unknown }).crs,
    objects: rest.objects ?? [],
  }).objects as CanonicalDoc["objects"];
  return {
    ...start,
    objects: [...(start.objects ?? []), ...completare],
  };
}
